import classNames from 'classnames';
import type { HTMLAttributes } from 'react';

import styles from './Divider.module.css';

export interface DividerProps extends HTMLAttributes<HTMLHRElement> {
  orientation?: 'horizontal' | 'vertical';
}

export const Divider = ({
  orientation = 'horizontal',
  className,
  ...rest
}: DividerProps) => (
  <hr
    className={classNames(styles.divider, styles[orientation], className)}
    aria-orientation={orientation}
    {...rest}
  />
);
